import PropTypes from 'prop-types';
import EventSignpostingIconsImpl from './event-signposting-icons.js';
import MojitoCore from 'mojito/core';

const UIView = MojitoCore.Presentation.UIView;

/**
 * View displaying event signposting icons like bet builder, price boost, streaming and neutral venue.
 *
 * @class EventSignpostingIcons
 * @memberof Mojito.Presentation.Components
 */

/**
 * EventSignpostingIcons prop types.
 *
 * @property {boolean} [hasStreaming = false] - Boolean indicating if event has streaming available.
 * @property {boolean} [isNeutralVenue = false] - Boolean indicating if event is played at neutral venue.
 * @property {boolean} [hasBoostedMarkets = false] - Boolean indicating if event has price boosted markets.
 * @property {boolean} [hasBetBuilderMarket = false] - Boolean indicating if event has bet builder.
 *
 * @memberof Mojito.Presentation.Components.EventSignpostingIcons
 */

const propTypes = {
    hasStreaming: PropTypes.bool,
    isNeutralVenue: PropTypes.bool,
    hasBoostedMarkets: PropTypes.bool,
    hasBetBuilderMarket: PropTypes.bool,
};

const defaultProps = {
    hasStreaming: false,
    isNeutralVenue: false,
    hasBoostedMarkets: false,
    hasBetBuilderMarket: false,
};

export default UIView('EventSignpostingIcons', EventSignpostingIconsImpl, propTypes, defaultProps);
